export default {
	titreBienvenueQuestionnaire: 'BIENVENUE SUR LE QUESTIONNAIRE RISQUES PROFESSIONNELS',
	nbDossiers: 'Pas de dossiers à traiter | {n} dossier | {n} dossiers',
	aucunEmployeur: 'Aucun employeur associé à ce dossier',
	listeDesDossiersATraiter: 'Liste des dossiers à traiter'
};
